import i18n from '@/plugins/i18n';
import legacyI18n from '@/i18n';
import { env } from '@/env';
import vuetify from '@/plugins/vuetify';

const SUPPORTED_LANGUAGES = ['es', 'en'];

const normalizeLocale = function(language: string): string {
  const normalized = String(language || '').trim().toLowerCase();

  if (normalized.startsWith('en')) {
    return 'en';
  }

  if (normalized.startsWith('es')) {
    return 'es';
  }

  return normalized;
};

const changeLocale = function(language: string, saveLanguage = false) {
  const normalizedLanguage = normalizeLocale(language);
  const nextLanguage = normalizedLanguage || i18n.fallbackLocale.toString();

  i18n.locale = nextLanguage;
  legacyI18n.locale = nextLanguage;
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = nextLanguage;
  }
  if (vuetify.framework?.lang) {
    vuetify.framework.lang.current = nextLanguage;
  }
  if (saveLanguage) {
    localStorage.setItem('locale', nextLanguage);
  }
};

export { changeLocale, normalizeLocale };

const getTopLanguages = function(): string[] {
  const configured = (env.topLanguages || '')
    .split(',')
    .map((lang) => normalizeLocale(lang))
    .filter((lang) => SUPPORTED_LANGUAGES.includes(lang));

  return [...new Set(['es', ...configured, 'en'])];
};

export { getTopLanguages };
